import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useClickOutside from '../../../../Hooks/useClickOutside';
import UseTimeCountdown from '../../../../Hooks/UseTimeCountdown';
import { filterCollectionsData } from '../../../../Shared/DiscoverPageFakeData';
import { exploreEtherData } from '../../../../Shared/ExploreDataFactory';
import { FilterSection } from './FilterSection/FilterSection';


export interface IDiscoverExploreSectionProps {
}

export function DiscoverExploreSection(props: IDiscoverExploreSectionProps) {
    let [searchParams, setSearchParams] = useSearchParams();
    let navigate = useNavigate();


    // for Explore NFTs -----------------------------
    const [exploreNFTDataInDisco, setExploreNFTDataInDisco] = React.useState(exploreEtherData)

    const handleExploreNFTOnClick = (id: number) => {
        navigate(`/exploreNftDetails/${id}/bids`)
    }
    const handleExploreNFTLoveOnClick = (index: number) => {
        const previousData = [...exploreNFTDataInDisco]
        const findMatchData = previousData[index]

        if (findMatchData.nftPostData.isMyloves) {
            findMatchData!.nftPostData.loves = findMatchData.nftPostData.loves - 1
            findMatchData.nftPostData.isMyloves = false;
            setExploreNFTDataInDisco(previousData)
        } else {
            findMatchData!.nftPostData.loves = findMatchData.nftPostData.loves + 1
            findMatchData.nftPostData.isMyloves = true;
            setExploreNFTDataInDisco(previousData)
        }
    }

    //handle Explore nft three dot modal
    const [exploreNFTThreeDotText, setExploreNFTThreeDotText] = useState('')
    const exploreNFTThreeDotModalRefs = React.useRef(new Array())
    const [clickedExploreNFTThreeDotIndex, setClickedExploreNFTThreeDotIndex] = useState(-1)
    const [isExploreNFTThreeDotModalOpen, setIsExploreNFTThreeDotModalOpen] = React.useState(() => [].map((x) => false));

    useClickOutside({ current: exploreNFTThreeDotModalRefs.current[clickedExploreNFTThreeDotIndex] }, () => {
        const newVisibilities = [...isExploreNFTThreeDotModalOpen];
        newVisibilities[clickedExploreNFTThreeDotIndex] = false;
        setIsExploreNFTThreeDotModalOpen(newVisibilities);
    })
    const hanldeExploreNFTThreeDotBtn = (index: any) => {
        const newVisibilities = [...isExploreNFTThreeDotModalOpen];
        newVisibilities[index] = !newVisibilities[index];

        setIsExploreNFTThreeDotModalOpen(newVisibilities);
        setClickedExploreNFTThreeDotIndex(index)
    };

    useEffect(() => {
        const arrayData = exploreNFTThreeDotModalRefs.current.map((data, index) => `${index}`)
        setIsExploreNFTThreeDotModalOpen(() => arrayData.map((x) => false));
    }, [])









    // explore filter modal
    const [filterModalOpen, setFilterModalOpen] = React.useState(false)
    const filterModalRef = React.useRef(null)
    useClickOutside(filterModalRef, () => setFilterModalOpen(false))

    const [collectionsData, setCollectionsData] = React.useState<any>(filterCollectionsData)
    const [filteredTags, setFilteredTags] = useState<any>({
        type: '',
        bundleItmes: '',
        sort: '',
        minPrice: -1,
        maxPrice: -1,
        collections: [],
    })

    const type = searchParams.get('type')
    const bundleItmes = searchParams.get('bundleItmes')
    const sort = searchParams.get('sort')
    const minPrice = searchParams.get('minPrice')
    const maxPrice = searchParams.get('maxPrice')
    const collections = searchParams.get('collections')?.split('-')
    useEffect(() => {
        const previousFilteredTags: any = { ...filteredTags }


        if (type?.toLowerCase() !== "all") {
            previousFilteredTags.type = type
        } else {
            previousFilteredTags.type = ''
        }
        if (bundleItmes?.toLowerCase() !== "all") {
            previousFilteredTags.bundleItmes = bundleItmes
        } else {
            previousFilteredTags.bundleItmes = ''
        }
        if (sort?.toLowerCase() !== "newest") {
            previousFilteredTags.sort = sort
        } else {
            previousFilteredTags.sort = ''
        }
        if (minPrice) {
            previousFilteredTags.minPrice = minPrice
        } else {
            previousFilteredTags.minPrice = -1
        }
        if (maxPrice) {
            previousFilteredTags.maxPrice = maxPrice
        } else {
            previousFilteredTags.maxPrice = -1
        }
        if (collections) {
            collections.map(colleId => {
                if (parseInt(colleId)) {
                    const getCollectionsData = collectionsData[parseInt(colleId) - 1]

                    if (previousFilteredTags.collections.indexOf(getCollectionsData.collectionName) === -1) {
                        previousFilteredTags.collections.push(getCollectionsData.collectionName)
                    }

                }
            })
        } else {
            previousFilteredTags.collections = []
        }

        setFilteredTags(previousFilteredTags)
    }, [searchParams])



    const hanldeFiltaredItemDelete = (itemName: any, colleName?: any, colleIndex?: number) => {
        const prevFilteredCollection: any = { ...filteredTags }

        if (itemName !== 'collections') {
            prevFilteredCollection[itemName] = ''
            setFilteredTags(prevFilteredCollection);
            searchParams.delete(itemName)

            const newParams: { [key: string]: string } = {};
            searchParams.forEach((value: string, key: string) => {
                newParams[key] = value;
            });
            setSearchParams(newParams)
        }
        else {
            const withoutClosedCate = prevFilteredCollection.collections.filter((cate: string) => cate !== colleName)
            prevFilteredCollection.collections = withoutClosedCate
            setFilteredTags(prevFilteredCollection);

            const findCollectionForId = collectionsData.find((data: any) => data.collectionName === colleName).id
            const withoutClosedId = collections?.filter(id => parseInt(id) !== findCollectionForId).join('-')

            if (withoutClosedId!.length > 0) {
                searchParams.set('collections', `${withoutClosedId}`)
            } else {
                searchParams.delete('collections')
            }
            const newParams: { [key: string]: string } = {};
            searchParams.forEach((value: string, key: string) => {
                newParams[key] = value;
            });
            setSearchParams(newParams)
        }
    }






    return (
        <div className="mt-14">
            <div className="flex justify-between items-center mb-5">
                <div className="relative inline-block">
                    <h1 className="xs:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Explore</h1>
                    <div className="bottom-1 absolute -right-4">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                    <stop offset={0} stopColor="#00dbff" />
                                    <stop offset="0.529" stopColor="#e315e8" />                                        <stop offset={1} stopColor="#ffd817" />
                                </linearGradient>
                            </defs>
                            <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                        </svg>
                    </div>
                </div>

                <button className="text-base text-white"
                    onClick={() => setFilterModalOpen(!filterModalOpen)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="34.978" height="35.012" viewBox="0 0 34.978 35.012">
                        <path id="filter" d="M1.093,5.935H17.735a5.091,5.091,0,0,0,9.944,0h6.206a1.093,1.093,0,0,0,0-2.186H27.679a5.09,5.09,0,0,0-9.943,0H1.093a1.093,1.093,0,0,0,0,2.186ZM19.8,4.845s0-.008,0-.012a2.9,2.9,0,0,1,5.808,0v.016a2.9,2.9,0,0,1-5.808,0ZM33.885,28.581H27.679a5.09,5.09,0,0,0-9.943,0H1.093a1.093,1.093,0,1,0,0,2.186H17.735a5.091,5.091,0,0,0,9.944,0h6.206a1.093,1.093,0,0,0,0-2.186Zm-11.178,4a2.907,2.907,0,0,1-2.9-2.9v0s0-.008,0-.012a2.9,2.9,0,0,1,5.808,0v.016a2.907,2.907,0,0,1-2.9,2.9ZM33.885,16.165H17.243a5.091,5.091,0,0,0-9.944,0H1.093a1.093,1.093,0,1,0,0,2.186H7.3a5.09,5.09,0,0,0,9.943,0H33.885a1.093,1.093,0,1,0,0-2.186Zm-18.711,1.09s0,.008,0,.012a2.9,2.9,0,0,1-5.808,0v-.016a2.9,2.9,0,0,1,5.808,0Z" transform="translate(0 0.248)" fill="#6f6dab" />
                    </svg>
                </button>
            </div>


            <div className="flex flex-wrap">
                {filteredTags.maxPrice > 0 &&
                    <motion.div
                        initial="hidden"
                        animate="visible"
                        variants={{
                            hidden: { opacity: 0 },
                            visible: { opacity: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        transition={{ duration: 0.2 }}
                        className="flex justify-center items-center gradientBG rounded-full py-1 px-2 sm:py-2 sm:px-3.5 mr-3 mb-2.5">

                        <p className="text-white font-semibold whitespace-nowrap text-xxs xsm:text-xs sm:text-sm select-none">Maximum Price: {filteredTags.maxPrice}</p>

                        <button className="ml-2" onClick={() => hanldeFiltaredItemDelete('maxPrice')}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </motion.div>
                }
                {filteredTags.minPrice > 0 &&
                    <motion.div
                        initial="hidden"
                        animate="visible"
                        variants={{
                            hidden: { opacity: 0 },
                            visible: { opacity: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        transition={{ duration: 0.2 }}
                        className="flex justify-center items-center gradientBG rounded-full py-1 px-2 sm:py-2 sm:px-3.5 mr-3 mb-2.5">

                        <p className="text-white font-semibold whitespace-nowrap text-xxs xsm:text-xs sm:text-sm select-none">Minmum Price: {filteredTags.minPrice}</p>

                        <button className="ml-2" onClick={() => hanldeFiltaredItemDelete('minPrice')}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </motion.div>
                }
                {filteredTags.sort && filteredTags.sort !== '' &&
                    <motion.div
                        initial="hidden"
                        animate="visible"
                        variants={{
                            hidden: { opacity: 0 },
                            visible: { opacity: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        transition={{ duration: 0.2 }}
                        className="flex justify-center items-center gradientBG rounded-full py-1 px-2 sm:py-2 sm:px-3.5 mr-3 mb-2.5">

                        <p className="text-white font-semibold whitespace-nowrap text-xxs xsm:text-xs sm:text-sm select-none">{filteredTags.sort}</p>

                        <button className="ml-2" onClick={() => hanldeFiltaredItemDelete('sort')}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </motion.div>
                }
                {filteredTags.bundleItmes && filteredTags.bundleItmes !== '' &&
                    <motion.div
                        initial="hidden"
                        animate="visible"
                        variants={{
                            hidden: { opacity: 0 },
                            visible: { opacity: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        transition={{ duration: 0.2 }}
                        className="flex justify-center items-center gradientBG rounded-full py-1 px-2 sm:py-2 sm:px-3.5 mr-3 mb-2.5">

                        <p className="text-white font-semibold whitespace-nowrap text-xxs xsm:text-xs sm:text-sm select-none">{filteredTags.bundleItmes}</p>

                        <button className="ml-2" onClick={() => hanldeFiltaredItemDelete('bundleItmes')}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </motion.div>
                }
                {filteredTags.type && filteredTags.type !== '' &&
                    <motion.div
                        initial="hidden"
                        animate="visible"
                        variants={{
                            hidden: { opacity: 0 },
                            visible: { opacity: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        transition={{ duration: 0.2 }}
                        className="flex justify-center items-center gradientBG rounded-full py-1 px-2 sm:py-2 sm:px-3.5 mr-3 mb-2.5">

                        <p className="text-white font-semibold whitespace-nowrap text-xxs xsm:text-xs sm:text-sm select-none">{filteredTags.type}</p>

                        <button className="ml-2" onClick={() => hanldeFiltaredItemDelete('type')}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </motion.div>
                }

                {filteredTags.collections.length > 0 && filteredTags.collections.map((name: any, index: number) =>
                    <motion.div
                        initial="hidden"
                        animate="visible"
                        variants={{
                            hidden: { opacity: 0 },
                            visible: { opacity: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        transition={{ duration: 0.2 }}
                        className="flex justify-center items-center gradientBG rounded-full py-1 px-2 sm:py-2 sm:px-3.5 mr-3 mb-2.5" key={name}>

                        <p className="text-white font-semibold whitespace-nowrap text-xxs xsm:text-xs sm:text-sm select-none">{name}</p>

                        <button className="ml-2" onClick={() => hanldeFiltaredItemDelete('collections', name, index)}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </motion.div>
                )}
            </div>


            {/* Explore Filter Modal */}
            <AnimatePresence>
                {filterModalOpen &&
                    <div
                        className="fixed sm:flex items-center justify-center z-50 inset-0" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="h-screen w-full flex items-center justify-center text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={filterModalOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={filterModalRef}
                                className="relative inline-block align-center bg-white dark:bg-[#292757] sm:rounded-2xl text-left shadow-2xl
                                transition-all sm:align-middle h-full w-full sm:h-auto sm:w-11/12 xl:max-w-5xl p-3 sm:p-7 filter_box overflow-y-auto">

                                <FilterSection setFilterModalOpen={setFilterModalOpen} />

                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>






            <div className="px-2 xxsm:px-8 xsm:px-0 mb-24 grid xs:grid-cols-1 xsm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-x-4 gap-y-4">
                {exploreNFTDataInDisco.map((data, index) =>
                    <div className="p-3 rounded-lg mt-5 h-full overflow-visible transition-all
                            bg-[#ffffff] dark:bg-[#292757] dark:hover:bg-[#CA12F6] hover:bg-[#CA12F6] border border-[#D8D8D8] dark:border-[#292757] group
                            "key={data.id} >
                        <div className="flex justify-between items-center">
                            <div className="flex justify-start items-center ml-3">
                                {data.profiles.map((prfl, index) =>
                                    <img key={index} src={prfl} alt="" className="w-6 h-6 -ml-2" />
                                )}
                            </div>
                            <div className="flex justify-end items-center">

                                <div
                                    className="flex cursor-pointer justify-between py-1 px-2 items-center rounded-full
                                            bg-[#F5F5F5] dark:bg-[#140D36] group-hover:bg-[#e589fb]"
                                    onClick={() => handleExploreNFTLoveOnClick(index)}>
                                    <p className="text-gray-800 dark:text-cusBlueWhite text-xs mr-0.5 
                                            dark:group-hover:text-white group-hover:text-white">{data.nftPostData.loves}</p>

                                    {data.nftPostData.isMyloves &&
                                        <motion.svg
                                            initial={{ scale: 0.5 }}
                                            animate={{ scale: 1 }}
                                            xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 group-hover:stroke-[#CA12F6]" fill="#CA12F6" viewBox="0 0 24 24" stroke="#CA12F6" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                        </motion.svg>
                                    }

                                    {!data.nftPostData.isMyloves &&
                                        <motion.svg
                                            initial={{ scale: 0.5 }}
                                            animate={{ scale: 1 }}
                                            xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 group-hover:stroke-[#CA12F6]" fill="none" viewBox="0 0 24 24" stroke="#6f6dab" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                        </motion.svg>
                                    }
                                </div>


                                <div className="relative" ref={(el) => exploreNFTThreeDotModalRefs.current[index] = el}>
                                    <button className="ml-3 three_dot_btn" onClick={() => hanldeExploreNFTThreeDotBtn(index)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={5} height={18} viewBox="0 0 5 21">
                                            <g id="Group_1481" data-name="Group 1481" transform="translate(0)">
                                                <circle className="group-hover:fill-white" id="Ellipse_374" data-name="Ellipse 374" cx="2.5" cy="2.5" r="2.5" transform="translate(0)" fill="#6f6dab" />
                                                <circle className="group-hover:fill-white" id="Ellipse_375" data-name="Ellipse 375" cx="2.5" cy="2.5" r="2.5" transform="translate(0 8)" fill="#6f6dab" />
                                                <circle className="group-hover:fill-white" id="Ellipse_376" data-name="Ellipse 376" cx="2.5" cy="2.5" r="2.5" transform="translate(0 16)" fill="#6f6dab" />
                                            </g>
                                        </svg>
                                    </button>
                                    <div className="absolute right-0 top-6 z-50">
                                        <AnimatePresence>
                                            {isExploreNFTThreeDotModalOpen[index] &&
                                                <motion.div
                                                    initial={{ height: 0, width: 0 }}
                                                    animate={{ height: "auto", width: '' }}
                                                    exit={{ height: 0, width: 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    className="overflow-hidden w-full max-w-[192px] bg-white border-2 dark:border-[#ffffff10] shadow-2xl shadow-[#00000050] dark:bg-[#363375] rounded"
                                                >
                                                    {["Place floor bid", "New Bid", "Refresh Metadata", "Share", "Open original on IPFS", "Report"].map(item =>
                                                        <div
                                                            className="w-full py-1.5 cursor-pointer hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 text-left"
                                                            key={item}
                                                            onClick={() => hanldeExploreNFTThreeDotBtn(index)}>
                                                            <h5 className="text-l-LightBlack dark:text-white text-base whitespace-nowrap font-semibold
                                                                    overflow-hidden overflow-ellipsis">{item}</h5>
                                                        </div>
                                                    )}
                                                </motion.div>
                                            }
                                        </AnimatePresence>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="h-[180px] xxsm:h-[224px] xsm:h-[180px] sm:h-[216px] md:h-[176px] relative mt-2 rounded-xl">
                            <div className="w-full h-full rounded-lg overflow-hidden">
                                <img src={data.thumb} alt="" className="w-full h-full object-cover hover:scale-125 transition-all" />
                            </div>

                            <div className="w-9/12 rounded-tr-xl bg-cusBlack absolute left-0 bottom-0 p-1 flex justify-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={16} height={15} viewBox="0 0 16 15">
                                    <defs>
                                        <clipPath id="clip-path">
                                            <rect id="Rectangle_814" data-name="Rectangle 814" width={16} height={15} transform="translate(0 0)" fill="#fb0" />
                                        </clipPath>
                                    </defs>
                                    <g id="Group_1121" data-name="Group 1121" transform="translate(0 0)" clipPath="url(#clip-path)">
                                        <path id="Path_662" data-name="Path 662" d="M113.614,342c-3.234,1.864-2.846,7.114-2.846,7.114a2.527,2.527,0,0,1-1.423-2.608,5.782,5.782,0,0,0-2.846,4.979,5.691,5.691,0,0,0,11.382,0c0-4.624-4.268-5.573-4.268-9.485Zm-.923,13.216a2.134,2.134,0,1,1-1.033-4.142c2.761-.688,3.107-2.242,3.107-2.242s1.377,5.523-2.075,6.383Z" transform="translate(-104.749 -341.967)" fill="#fb0" />
                                    </g>
                                </svg>
                                <UseTimeCountdown endDate={data.time} />
                            </div>
                        </div>

                        <div className="mt-4 mb-2 flex justify-between items-center">
                            <h4 className="text-sm text-cusBlack dark:text-white group-hover:text-white ">"{data.title}</h4>
                            <svg className="w-[11px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                            </svg>

                        </div>


                        <p className="text-cusBlack dark:text-cusBlueWhite group-hover:text-[#A4B1E2] text-xs text-left">{data.author}</p>

                        <div className="flex justify-between items-center">
                            <h4 className="text-xs font-semibold text-cusBlack dark:text-white group-hover:text-white">{data.price} ETH</h4>
                            <p className="text-xs text-cusBlack dark:text-cusBlueWhite group-hover:text-[#A4B1E2] ">1/{data.aMA}</p>

                            <button onClick={() => handleExploreNFTOnClick(data.id)} className="font-semibold
                                    bg-cusBrightLink dark:bg-black text-sky-800 dark:text-cusLink text-xs px-2.5 py-1 rounded-full">
                                {data.authorShow ? "Place a Bid" : "Buy Now"}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>

    );
}
